"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _propTypes2 = require("../../constants/propTypes");

var _colors = require("../../constants/colors");

var _styles = require("../../styles");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _noDataInsert = _interopRequireDefault(require("../noDataInsert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Display = function Display(_ref) {
  var batteryCoordinates = _ref.batteryCoordinates,
      endMillis = _ref.endMillis,
      isLoading = _ref.isLoading,
      startMillis = _ref.startMillis;
  return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    animation: "noWobble",
    dataTestid: "battery-daily-percentage-chart",
    height: 100,
    margin: {
      left: 70,
      right: 0
    },
    xDomain: [startMillis, endMillis],
    xType: "time",
    yDomain: [0, 100]
  }, (0, _noDataInsert["default"])(startMillis, endMillis, isLoading, batteryCoordinates.maxCoordinates), /*#__PURE__*/_react["default"].createElement(_reactVis.AreaSeries, {
    data: batteryCoordinates.areaCoordinates,
    style: {
      fill: _colors.LIGHT_GREEN,
      stroke: _colors.LIGHT_GREEN,
      strokeWidth: 2
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    curve: "curveLinear",
    data: batteryCoordinates.maxCoordinates,
    style: {
      stroke: _colors.DARK_GREEN,
      strokeWidth: 2,
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    curve: "curveLinear",
    data: batteryCoordinates.minCoordinates,
    style: {
      stroke: _colors.DARK_GREEN,
      strokeWidth: 2,
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.HorizontalGridLines, {
    style: _styles.dashedGridStyle,
    tickTotal: 3
  }));
};

Display.propTypes = {
  batteryCoordinates: _propTypes["default"].shape({
    maxCoordinates: _propTypes2.coordinatePropTypes,
    minCoordinates: _propTypes2.coordinatePropTypes,
    areaCoordinates: _propTypes2.coordinatePropTypes
  }),
  endMillis: _propTypes["default"].number.isRequired,
  isLoading: _propTypes["default"].bool,
  startMillis: _propTypes["default"].number.isRequired
};
Display.defaultProps = {
  batteryCoordinates: {
    maxCoordinates: [],
    minCoordinates: [],
    areaCoordinates: []
  },
  isLoading: false
};
var _default = Display;
exports["default"] = _default;